/**
 * Builds the URL for PDF downloads served via the backend (SharePoint proxy).
 * Production: same-origin `/api/pdf` (e.g. Azure SWA).
 * Development: defaults to `http://localhost:3001` so the browser hits Express directly.
 * Same-origin `/api/pdf` via CRA proxy can sometimes return `index.html`, which loads React on
 * `/api/pdf` and shows "Page not found".
 * Set `REACT_APP_API_URL` (optional `/api/folders` suffix) to override — e.g. remote API for testing.
 */
const DEV_PDF_API_ORIGIN = 'http://localhost:3001';

export function getPdfDownloadUrl(serverRelativeUrl: string, fileName: string): string {
  const isProd = process.env.NODE_ENV === 'production';
  const fromEnv = (process.env.REACT_APP_API_URL || '').replace(/\/api\/folders\/?$/, '');
  const base = isProd ? '' : fromEnv || DEV_PDF_API_ORIGIN;
  const params = new URLSearchParams({
    serverRelativeUrl,
    fileName,
  });
  const path = `/api/pdf?${params.toString()}`;
  return `${base.replace(/\/$/, '')}${path}`;
}
